export default {
  props: {
    breadcrumbs: {
      type: [Object, Array],
      default: [],
    },
  },
}
